import moment from 'moment';
import JSZip from 'jszip';

export const toOpenData = (gameWithInPlay) => {
  console.log(gameWithInPlay);
  const batterBox = {
    away: toBatterBox(gameWithInPlay.away.box),
    home: toBatterBox(gameWithInPlay.home.box),
  };
  const pitcherBox = {
    away: toPitcherBox(gameWithInPlay.away.box),
    home: toPitcherBox(gameWithInPlay.home.box),
  };
  const PAList = {
    away: toPAList(gameWithInPlay.PA_list.filter((PA) => PA.side === 'AWAY')),
    home: toPAList(gameWithInPlay.PA_list.filter((PA) => PA.side === 'HOME')),
  };
  return toGame(gameWithInPlay, batterBox, pitcherBox, PAList);
};

export const downloadOpenData = (title, openData) => {
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(openData));
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', title + '.json');
  document.body.appendChild(downloadAnchorNode);
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};

export const batchDownloadOpenData = (filename, openDataGames) => {
  const zip = new JSZip();

  // 將每個物件添加到 zip 檔案中
  const full = [];
  openDataGames.forEach(({ title, openData }) => {
    zip.file(title + '.json', JSON.stringify(openData));
    full.push(openData);
  });
  zip.file(filename + '.json', JSON.stringify(full));

  // 生成 blob
  zip
    .generateAsync({ type: 'blob' })
    .then(function (blob) {
      // 創建 blob URL
      const url = URL.createObjectURL(blob);
      const downloadAnchorNode = document.createElement('a');
      downloadAnchorNode.href = url;
      downloadAnchorNode.download = filename;
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
      downloadAnchorNode.remove();
      URL.revokeObjectURL(url);
    })
    .catch(function (error) {
      console.error('Error creating zip file', error);
    });
};

const toGame = (game, batterBox, pitcherBox, PAList) => {
  return {
    seasonId: game.season.uniqid,
    season: game.season.title,
    seq: game.seq,
    date: moment(game.info.started_at).format('YYYY-MM-DD HH:mm'),
    stadium: game.info.location,
    awayTeamId: game.away.team_uniqid,
    awayTeam: game.away.team,
    awayScores: game.away.scores,
    awayBatterBox: batterBox.away,
    awayPitcherBox: pitcherBox.away,
    awayPAList: PAList.away,
    homeTeamId: game.home.team_uniqid,
    homeTeam: game.home.team,
    homeScores: game.home.scores,
    homeBatterBox: batterBox.home,
    homePitcherBox: pitcherBox.home,
    homePAList: PAList.home,
  };
};

const toBatterBox = (sideBox) => {
  return sideBox.battings.map((batting) => ({
    order: batting.order,
    playerId: batting.player.uniqid,
    playerNumber: batting.player.number,
    playerName: batting.player.name,
    PA: batting.PA,
    AB: batting.AB,
    R: batting.R,
    H: batting.H,
    RBI: batting.RBI,
    '2B': batting['2B'],
    '3B': batting['3B'],
    HR: batting.HR,
    GIDP: batting.GIDP,
    DP: batting.DP,
    TP: batting.TP,
    BB: batting.BB,
    IBB: batting.IBB,
    HBP: batting.HBP,
    SO: batting.SO,
    SH: batting.SH,
    SF: batting.SF,
    E: batting.E,
    SB: batting.SB,
    CS: batting.CS,
  }));
};

const toPitcherBox = (sideBox) => {
  return sideBox.pitchings.map((pitching) => ({
    order: pitching.order,
    playerId: pitching.player.uniqid,
    playerNumber: pitching.player.number,
    playerName: pitching.player.name,
    IPOuts: pitching.IP_out,
    NP: pitching.NP,
    BF: pitching.BF,
    H: pitching.H,
    HR: pitching.HR,
    BB: pitching.BB,
    IBB: pitching.IBB,
    HB: pitching.HB,
    SO: pitching.SO,
    R: pitching.R,
    ER: pitching.ER,
  }));
};

const toPAList = (PAList) => {
  return PAList.map((PA) => ({
    inning: PA.inning,
    scored: PA.is_scoring,
    batterName: PA.batter.name,
    batterHand: PA.batter.b_hand,
    pitcherName: PA.pitcher.name,
    pitcherHand: PA.pitcher.p_hand,
    catcherName: PA.catcher.name,
    paRound: PA.PA_round,
    paOrder: PA.PA_order,
    isPH: PA.pinch === 'PH',
    awayScores: PA.away_score,
    homeScores: PA.home_score,
    strikes: PA.strikes,
    balls: PA.balls,
    outs: PA.outs,
    bases: PA.bases,
    homeWE: PA.home_WE,
    RE: PA.RE,
    pitchCodes: PA.ball_counts,
    events: PA.events.map((event, eventIndex) => ({
      type: event.type,
      inPlay: event.in_play,
      isStrike: event.is_strike,
      isBall: event.is_ball,
      pitcherName: event.pitcher.name,
      catcherName: event.catcher.name,
      batterName: event.batter.name,
      pitchCode: event.pitch?.code ?? null,
      pitchType: event.pitch?.type ?? null,
      velocity: event.pitch?.velocity ?? null,
      coordX: event.pitch?.coord_x ?? null,
      coordY: event.pitch?.coord_y ?? null,
      runners: PA.runners
        .filter((runner) => runner.event_index === eventIndex)
        .map((runner) => ({
          type: runner.code,
          runnerName: runner.runner.name,
          isOut: runner.is_out,
          scored: runner.is_scoring,
          isRBI: runner.is_RBI,
          isER: runner.is_ER,
          ERPitcherName: runner.count_on_pitcher?.name ?? null,
        })),
    })),
    result: PA.result,
    RBI: PA.RBI,
    locationCode: PA.location_code,
    trajectory: PA.trajectory,
    hardness: PA.hardness,
    endAwayScores: PA.end_away_score,
    endHomeScores: PA.end_home_score,
    endOuts: PA.end_outs,
    endBases: PA.end_bases,
    WPA: PA.WPA,
    RE24: PA.RE24,
  }));
};
